import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getDataFromCorpNafath, sendCorpNafathVerification, verifyWathaq } from '../../store/actions/corporateAction';
import { getContentKeyAccToLang, setToken } from '../../utils/utils';
import { useEffect, useRef, useState } from 'react';
import { setNafathCode } from '../../store/slices/constantSlice';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { authLoading } = useSelector((state) => state.auth);
  const { authContent } = useSelector((state) => state.content);
  const { nafath_code, client_application_id } = useSelector((state) => state.constant);

  const [showModal, setShowModal] = useState(false);
  const [isNafathVarified, setIsNafathVerified] = useState(false);

  const doneRef = useRef(false);
  const mountedRef = useRef(true);
  const timerRef = useRef(null);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_wathq_verification?.data?.attributes, key, isArabic);
  };
  const user = location.state?.data;

  const handleNafathVerification = (values) => {
    const params = `${user?.clientId}&identificationNo=${values?.number}`;

    dispatch(
      sendCorpNafathVerification(params, () => {
        setShowModal(true);
      }),
    );
  };

  const handleSubmit = (values) => {
    const api_data = {
      crNo: values?.crNumber,
      clientId: user?.clientId,
      clientApplicationId: client_application_id,
      unifiedNumber: values?.unifiedNo,
    };
    dispatch(
      verifyWathaq(api_data, () => {
        navigate('/corporate-form');
      }),
    );
  };

  const closeModal = () => {
    clearTimer();
    setShowModal(false);
    dispatch(setNafathCode(null));
  };

  const clearTimer = () => {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (!showModal || doneRef.current) {
      clearTimer();
      return;
    }

    const checkOnce = () => {
      if (doneRef.current || !mountedRef.current) return;

      dispatch(
        getDataFromCorpNafath(user?.clientId, () => {
          if (doneRef.current || !mountedRef.current) return;

          doneRef.current = true;
          clearTimer();
          dispatch(setNafathCode(null));
          setIsNafathVerified(true);
          setShowModal(false);
        }),
      );
    };

    // Immediate execution
    checkOnce();

    // Start polling
    timerRef.current = setInterval(checkOnce, 10000);

    // Cleanup on dependency change / unmount
    return () => clearTimer();
  }, [showModal, user?.clientId, dispatch]);

  return {
    TextWeight,
    authLoading,
    getContentKey,
    isArabic,
    navigate,
    showModal,
    isNafathVarified,
    handleNafathVerification,
    handleSubmit,
    closeModal,
    nafath_code,
    doneRef,
  };
};
